import React, { memo } from "react";
import { ICellRendererParams } from "ag-grid-community";

import { GuestChip, MemberChip } from "fond/widgets/AccountSwitch";

interface TypeCellRendererProps extends ICellRendererParams {
  value: "Member" | "Guest";
}

const TypeCellRenderer: React.FC<TypeCellRendererProps> = memo(({ value }: TypeCellRendererProps) => {
  if (value === "Guest") {
    return <GuestChip label="Guest" size="small" data-testid="guest-chip" />;
  }

  return <MemberChip label="Member" size="small" data-testid="member-chip" />;
});

TypeCellRenderer.displayName = "TypeCellRenderer";

export default TypeCellRenderer;
